import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { ProfileInfoFragment } from '@/features/user-profile/graphql/fragments/ProfileInfo.fragment';

import UserBadge from '@/features/user-profile/components/UserBadge.vue';

import { useEditorialTracking } from '@/features/editorial/tracking';
import { influencerIds } from '@/features/user-profile/types';

import { computed } from 'vue';
import { ProfileType } from '@/@types/graphql-types';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBox',
  props: {
    profile: null,
    customProfileType: null,
    isHeader: { type: Boolean },
    hideBadge: { default: () => [] },
    hideAllBadges: { type: Boolean },
    size: null,
    linkProfile: { type: Boolean, default: true },
    isBadgeInline: { type: Boolean },
    additionalContexts: { default: () => [] }
  },
  emits: ["authorClick"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'authorClick', isNavigation: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { profile: ProfileInfoFragment, customProfileType?: string, isHeader?: boolean, hideBadge: ProfileType[], hideAllBadges?: boolean, size?: 'xsmall' | 'small' | 'large', linkProfile: boolean, isBadgeInline?: boolean, additionalContexts: SnowplowContext[] };

const { trackEditorial } = useEditorialTracking();





const isInfluencer = computed(
	() => props.profile.profileType === ProfileType.Influencer || influencerIds.includes(props.profile.id)
);

async function handleClick() {
	// Only handle if this is a link navigation
	if (!props.linkProfile || !props.profile.profileUrl) {
		return;
	}

	trackEditorial('clickOnAuthor', {
		spec: { property: props.profile.id, useLastRoute: true },
		contexts: props.additionalContexts,
		immediate: true,
	});

	emit('authorClick', props.linkProfile && props.profile.profileUrl != null);
}

return { __sfc: true,trackEditorial, props, emit, isInfluencer, handleClick, UserBadge, faCheck }
}

})